<header>
    <div class="header-content">
        <span class="hamburger" (click)="toggleNav()">&#9776;</span>
        <div class="d-flex justify-content-between w-100">
      <div class="header-breadcrumb">
        <h1 class="d-block">R<span class="d-none d-md-inline">ecord </span>R<span class="d-none d-md-inline">etrieval</span> Client Portal</h1>
        <h6>Home</h6>
      </div>
      <div class="d-flex align-items-stretch">
        <div id="user-profile-dropdown" class="profile-container" (click)="toggleProfileDropdown()">
          <i alt="Profile Icon" class="pt-1 fa fa-user"></i>
          <div class="profile-info">
            <div class="d-flex flex-column">
              <span class="profile-name">{{firstName || displayName}} {{lastName}}</span>
              <!-- FIXME, we need a selected field on API -->
              <div class="d-flex flex-row gap-0 align-items-center profile-designation">
                <span>{{accountname}}</span> <i *ngIf="accountname" class="pi pi-angle-right" style="color: #fff"></i> <span class="">{{ availableTenants?.[0]}}</span>
               </div>
            </div>
              <span class="fa fa-caret-down"></span>
          </div>
          <ul id="profile-dropdown" class="dropdown-menu">
            <li><a id="profile-dropdown-carrier-name" class="dropdown-item" href="#"><i class="pi pi-briefcase me-2"></i> Carrier Name</a>
              <ul class="m-0">
                <li *ngFor="let tenant of availableTenants; let i = index">
                  <a id="profile-dropdown-tenant-{{i+1}}" class="dropdown-item" href="#" (click)="changeTenant(tenant)">{{ tenant }}</a>
                </li>
              </ul>
            </li>
            <li><a id="logout" class="dropdown-item d-flex align-items-center" (click)="logout()"> <i class="pi pi-sign-out me-2"></i> Logout</a></li>
          </ul>
          <!-- <div id="profile-dropdown" class="profile-dropdown">
              <a href="#">Profile</a>
              <a href="#">Settings</a>
              <a href="#">Logout</a>
          </div> -->
        </div>
        <div class="d-flex align-items-center px-2">
        <button id="place-order" class="btn btn-primary mx-2" (click)="loadOrderInfoComponent()">Place Order</button>
        </div>
      </div>
      </div>
    </div>
  </header>